import Article from "./Article";
import Product from "./Product";
export var Card = {
  Article: Article,
  Product: Product
};
export default Card;